import React from 'react'

import * as S from './styled'

const Loader = ({position}) => {
  return (
    <S.OuterContainer position={position}>
      <div></div>
      <div></div>
      <div></div>
    </S.OuterContainer>
  )
}

export default Loader
